import { render, staticRenderFns } from "./componentRelationselect.vue?vue&type=template&id=7469191b&"
import script from "./componentRelationselect.vue?vue&type=script&lang=ts&"
export * from "./componentRelationselect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports